module.exports = __webpack_public_path__ + "img/0.06397947.png";